import { useParams } from 'react-router-dom';

export default function useAccountParam() : string {   
    const { accountId } = useParams();

    return accountId as string;
}